import { CREATE_ENTITY_ROUTE_NAME } from '/Router/constants';

export const hasLastPathSegmentCreateRouteName = (pathname: string) =>
  pathname.split('/').at(-1) === CREATE_ENTITY_ROUTE_NAME;
